import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { Button } from '@/Domain/components/Shared/Button/Button';

interface PlaceholderDomainNoticeProps {
  onBack: () => void;
}

const containerVariants = {
  hidden: { opacity: 0, y: 8 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.25, ease: 'easeOut' } },
};

export const PlaceholderDomainNotice = ({ onBack }: PlaceholderDomainNoticeProps) => {
  const { t } = useTranslation('getting_started');

  return (
    <motion.div
      initial="hidden"
      animate="visible"
      variants={containerVariants}
      className="flex flex-col gap-5 bg-card border border-border rounded-2xl p-6"
      data-testid="gs-placeholder-domain-notice"
      role="alertdialog"
      aria-labelledby="gs-placeholder-domain-notice-title"
    >
      <div className="flex flex-col gap-1.5">
        <h2
          id="gs-placeholder-domain-notice-title"
          className="text-xl font-semibold text-foreground"
        >
          {t('placeholder_domain_notice.title')}
        </h2>
        <p className="text-sm text-muted-foreground">{t('placeholder_domain_notice.body')}</p>
      </div>

      <Button
        type="button"
        size="md"
        onClick={onBack}
        data-testid="gs-placeholder-domain-notice-back"
        className="w-full"
      >
        {t('placeholder_domain_notice.cta')}
      </Button>
    </motion.div>
  );
};
